import styled from "styled-components";
import DesignConstants from "../../../../../../constants/DesignConstants";
import PhaseSixIcon from "../../../../../../basic/phaseSixIcon/PhaseSixIcon";

export const WriteSentenceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: ${DesignConstants.SPACES.S};
    flex: 1;

    /* On mobile each score bubble sits above its card, so the sections need a
       clearly larger gap between them than the bubble has to its own card. */
    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        gap: ${DesignConstants.SPACES.M};
    }
`;

export const WordAndScoreWrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: start;
    gap: ${DesignConstants.SPACES.M};

    /* On mobile the score bubble doesn't fit next to the card, so it moves above it. */
    @media (max-width: ${process.env.REACT_APP_LOWER_GRID_STEP_BORDER}px) {
        flex-direction: column-reverse;
        align-items: flex-end;
        gap: ${DesignConstants.SPACES.XS};

        .word-row {
            align-self: stretch;
        }
    }

    &:first-child .word-row {
        border-top-left-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        border-top-right-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    }

    &:last-child .word-row {
        border-bottom: none;
        border-bottom-left-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
        border-bottom-right-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    }
`;

export const ItemWrapper = styled.div`
    padding: ${DesignConstants.SPACES.S} ${DesignConstants.SPACES.M} ${DesignConstants.SPACES.M}
        ${DesignConstants.SPACES.M};
    border-radius: ${DesignConstants.BORDER_RADIUS.SMALL_CONTAINER};
    background-color: ${DesignConstants.COLORS.WHITE};
    flex: 1;
`;

export const LinesContainer = styled.div`
    > div {
        padding: 0;
        border-radius: 0;
    }
`;

export const WordAndIconWrapper = styled.div`
    /* min-height instead of a fixed height so multi-line words grow the card
       instead of overflowing it. */
    min-height: ${DesignConstants.SPACES.M};
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: ${DesignConstants.FONT_SIZES.L};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
`;

export const Word = styled.p`
    min-width: 0;
    overflow-wrap: break-word;
`;

export const RemoveIcon = styled(PhaseSixIcon)`
    font-size: ${DesignConstants.FONT_SIZES.XL};
    font-weight: ${DesignConstants.FONT_WEIGHTS.SEMI_BOLD};
    cursor: pointer;
`;
